// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Creditor } from './creditor';
import { Meeting } from './meeting';
import { MeetingAttendanceResolution } from './meeting-attendance-resolution';
import { ProxyType } from './proxy-type';
import { Shareholder } from './shareholder';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class MeetingAttendance extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  meetingAttendanceId!: number;
  createdBy!: string;
  createdDate!: Date;
  creditorId?: number;
  flags?: number;
  isAttendee!: boolean;
  meetingId!: number;
  memo?: string;
  podamount!: number;
  poddate?: Date;
  podvotingAdmitted!: number;
  proxyTypeId?: number;
  representedBy?: string;
  shareholderId?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  creditor!: Creditor;
  meeting!: Meeting;
  meetingAttendanceResolutions!: MeetingAttendanceResolution[];
  proxyType!: ProxyType;
  shareholder!: Shareholder;
}

